(function($) {

var pageId = 'page-projects';
var page = '#' + pageId;

$(function() {
    $('body').on('click', page + ' .denied', function(e) {
        simple.dialog.message({
            content: $('#tpl-new-project-denied').html()
        });

        return false;
    })
    .on('click', page + ' .pin-projects .project .pin-icon', cancelPinProject)
    .on('click', page + ' .projects .project .pin-icon', pinProject)
    .on('ajax:success', '.resend-email-verify', function(e, result) {
        simple.dialog.message({
            content: result.success ? '验证邮件发送成功，请注意查收' : result.msg
        });
    })
    .on('click', page + ' .show-all', function(e) {
        e.preventDefault();
        $(this).parent().find('a.hide').removeClass('hide');
        $(this).remove();
    }).on('click', page + ' .projects.list-view .new-project-placeholder', function(e) {
        var $el = $(e.target);
        if ($el.is('.link-new-project') || $el.closest('.link-new-project').length) return;

        $(this).find('.link-new-project').trigger('click');
    });

    $(document).on('click', page + ' .link-view', function(e) {
        e.preventDefault();
        var $link = $(this);
        if ($link.hasClass('active')) {
            return;
        }

        $link.addClass('active')
            .siblings()
            .removeClass('active');

        if ($link.hasClass('link-grid-view')) {
            $(page).find('.projects, .pin-projects').removeClass('list-view')
                .addClass('grid-view');
            localStorage['projects-view/' + tower.me.guid] = 'grid';
        } else {
            $(page).find('.projects, .pin-projects').removeClass('grid-view')
                .addClass('list-view');
            localStorage['projects-view/' + tower.me.guid] = 'list';
        }
    });

});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    $('#nav-project').addClass('active');
    renderTip();
    tower.initProjectGroups();
    tower.projectBadge({
        targetParent: '#page-projects',
        target: '.project .edit-badge',
        autoSave: true,
        syncValue: false
    });

    var isListView = !!(localStorage['projects-view/' + tower.me.guid] == 'list');
    $page.find('.link-view').removeClass('active');
    if (isListView) {
        $page.find('.link-list-view').addClass('active');
        $page.find('.link-grid-view').removeClass('active');
        $page.find('.projects, .pin-projects').addClass('list-view').removeClass('grid-view');
    } else {
        $page.find('.link-list-view').removeClass('active');
        $page.find('.link-grid-view').addClass('active');
        $page.find('.projects, .pin-projects').removeClass('list-view').addClass('grid-view');
    }
    tower.updateProjectsSortable($(document).find('.projects'));
    tower.updateProjectsSortable($(document).find('.pin-projects'));
    tower.adjustReadableTime($page);
    tower.autoLoadProjects();
});

function pinProject(e) {
    e.preventDefault();
    e.stopPropagation();

    var target = $(e.currentTarget);
    var project = target.closest('.project');
    var accessId = project.data('access-id');

    $.ajax({
        url: project.data('pin-url'),
        type: 'post',
        dataType: 'json',
        data: {
            access_id: accessId
        },
        success: function(result) {
            if (result.success) {
                var $pinProjects = $('.pin-projects');
                var $project = $(result.html);

                project.fadeOut( function() {
                    $(this).remove();
                });
                $pinProjects.append($project);
            }

            if ($project && $project.length) {
                tower.highlight($project);
            }
        }
    });
}

function cancelPinProject(e) {
    e.preventDefault();
    e.stopPropagation();

    var target = $(e.currentTarget);
    var project = target.closest('.project');
    var accessId = project.data('access-id');

    $.ajax({
        url: project.data('cancel-pin-url'),
        type: 'post',
        dataType: 'json',
        data: {
            access_id: accessId
        },
        success: function(result) {
            if (result.success) {
                var $projects = $('.projects');
                var $project = $(result.html);
                var $newProjectPlaceholder = $projects.find('.new-project-placeholder');

                project.fadeOut( function() {
                    $(this).remove();
                });

                if ($newProjectPlaceholder.length) {
                    $newProjectPlaceholder.before($project);
                } else {
                    $projects.append($project);
                }
            }

            if ($project && $project.length) {
                tower.highlight($project);
            }
        }
    });
}

function renderTip() {
    if ($('.projects-tools').length == 0) {
        return;
    }

    // 创建项目
    $('#tip-new-project').removeClass('hide');

    // 熟悉 Tower 项目
    var $tip = $('#tip-welcome-project');
    var $welcome = $('.project-welcome');

    if ($welcome.length) {
        $tip.appendTo($welcome);
        $tip.removeClass('hide');
    }

    if ($welcome.is(':only-child')) {
        tower.showBubbleGuide({
            steps: [14]
        });

        $('.link-create-project').on('click', function() {
            $('#tpl-bubble-guide-14').remove()
            tower.bubbleGuideExpire({
                step: 14
            });
        })
    }
}

})(jQuery);
